import { LibraryConfig } from "@cloud4rain_c4r/digital-library";

export const environment = {
  production: false,
  baseUrl : 'https://api.ap-election.com/apa',
  publicimages:"https://api.ap-election.com/images/Media/",
  defaultLang:'ar',
  APIURL:"https://api.ap-election.com/apa/api/v1/",
  SSOURL:'https://api.ap-election.com/identity/api/v1/',
  hiringUrl:"https://api.ap-election.com/hiring/api/v1/",
  siteKey:'6LfpibArAAAAAA06vNFqxMrlonncY877lDn9daMZ',
  SERURL: 'https://api.ap-election.com/services/api/v1/',
  serv: 'services',
  sso: 'sso',
  local: 'local',
  localURL: 'http://localhost:4200',
  EncryptedKey:'XCVAD#$%A2344GFAds=-JSGD$$%f@3fr' ,
  sla: 'apa',
   hiring:'hiring',
  notificationUrl:"https://api.ap-election.com/notification/api/v1/",
  notification:"notification",
  notificationHub:"https://api.ap-election.com/notificationHub",

 libraryConfig: {
    projectType: 'apa' as const,
    API_URL: 'https://api.ap-election.com/library/api/v1/',
    API_AUTH_URL: 'https://api.ap-election.com/identityCore/api/v1/',
    URL_IMAGE: 'https://api.ap-election.com/Images/Media/',
    libraryUrl: 'https://api.ap-election.com/library/api/v1/',
    legislationUrl: 'https://api.ap-election.com/legislation/api/v1/',
    lawBooksUrl: 'https://api.ap-election.com/lawbooks/api/v1/',
    bookImageUrl: 'http://74.162.41.194:5015/'
  } as LibraryConfig,
};
